export default __webpack_public_path__ + "static/media/diamond-carat-2@3x.43a2b145.jpg";